import ModelBase from "./shared/model-base.js";

export interface AddressPosition {
  id: number;
  country_id: number | null;
  full_address: string | null;
  search_address: string | null;
  has_position: boolean;
  lat: number | null;
  lng: number | null;
}

interface ModelAttributes {
  id: string | number;
  name?: string;
  address?: string;
  price?: number;
  price_unit?: string;
  price_per_unit?: number;
  listing_status?: string;
  lease_period?: string;
  property_type?: string;
  building_size?: number;
  building_size_unit?: string;
  lot_size?: number;
  lot_size_unit?: string;
  year_built?: number;
  stories?: number;
  parking_info?: string;
  zoning?: string;
  cap_rate?: number;
  irr?: number;
  ltv?: number;
  description?: string;
  features?: string[];
  latitude?: number;
  longitude?: number;
  address_position_id?: number | null;
  address_position?: AddressPosition | null;
  image_urls?: string[];
  property_images?: { id: number; image_url: string; position: number }[];
  is_published?: boolean;
  published_at?: string;
  country_id: string | number;
  member_id?: string | number;
  created_at?: string;
  updated_at?: string;
}

const OPTIONS = {
  i18nModelName: "property",
  columns: [
    "id",
    "name",
    "address",
    "price",
    "price_unit",
    "price_per_unit",
    "listing_status",
    "lease_period",
    "property_type",
    "building_size",
    "building_size_unit",
    "lot_size",
    "lot_size_unit",
    "year_built",
    "stories",
    "parking_info",
    "zoning",
    "cap_rate",
    "irr",
    "ltv",
    "description",
    "features",
    "latitude",
    "longitude",
    "address_position_id",
    "address_position",
    "image_urls",
    "property_images",
    "is_published",
    "published_at",
    "country_id",
    "member_id",
    "created_at",
  ],
  editColumns: {},
};

interface Property extends ModelAttributes {}

class Property extends ModelBase {
  constructor(attributes: Partial<ModelAttributes> = {}) {
    super(OPTIONS, attributes);
  }
}

export default Property;
